import React from "react";
import { DatePicker } from "@pd/pd-ui-kit";
import type { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";

import s from "./GRFilter.module.less";

export const GRFilter = () => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const { searchField } = useGetLocationData();

  const currentYear = new Date().getFullYear();

  // Как в старом DealerInfoPanel: доступны для выбора только последние 10 лет
  const disabledDate = (current: Dayjs) => {
    const year = current.year();
    return year > currentYear || year <= currentYear - 10;
  };

  const handleChange = (date: Dayjs | null) => {
    date && setData("searchField", String(date.year()));
  };

  return (
    <div className={s.field}>
      <span className={s.label}>{t("globalRating.show_for")}</span>
      <DatePicker
        picker="year"
        format="YYYY"
        size="small"
        allowClear={false}
        className={s.datePicker}
        value={new Date(searchField ? +searchField : currentYear, 0, 1)}
        disabledDate={disabledDate}
        onChange={handleChange}
      />
    </div>
  );
};
